// extracted by mini-css-extract-plugin
export var statItem = "_cg-1";
export var statsRow = "_cg-0";